<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-card flat dense>
      <v-card-title>
        <slot name="title">
          {{ title }}
        </slot>
        <v-spacer></v-spacer>
        <v-btn icon :dark="!!options.color" @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <slot name="subtitle">
        <v-card-subtitle> </v-card-subtitle>
      </slot>
      <slot name="card">
        <v-card-text v-show="!!message" :class="options.messageClass">
          {{ message }}
        </v-card-text>
      </slot>
      <slot name="actions">
        <v-card-actions>
          <slot name="buttons" :cancel="cancel" :agree="agree">
            <v-btn large outlined depressed color="grey" @click.native="cancel">
              {{ options.cancelBtnText }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              large
              depressed
              :color="options.agreeBtnColor"
              @click.native="agree"
            >
              {{ options.agreeBtnText }}
            </v-btn>
          </slot>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DefaultDialog',

  props: {
    value: {
      type: Object,
      default: () => ({ dialog: false })
    }
  },

  data: () => ({
    dialog: false,
    resolve: () => {},
    reject: () => {},
    message: null,
    title: null,
    options: {}
  }),

  computed: {
    defaultOptions() {
      return {
        color: '',
        width: 500,
        titleClass: '',
        messageClass: '',
        cancelBtnText: this.$t('BUTTON.CANCEL'),
        agreeBtnText: this.$t('BUTTON.OK'),
        agreeBtnColor: 'primary'
      };
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'changeComponentData'
    }
  },

  mounted() {
    this.options = this.defaultOptions;
  },

  methods: {
    changeComponentData(v) {
      if (!v) {
        return;
      }

      if (v.dialog === !!v.dialog) {
        this.dialog = v.dialog;
      }

      if (v.options) {
        this.options = { ...this.options, ...v.options };
      }
    },

    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.defaultOptions, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.closeDialog();
      this.$emit('agree');
    },

    cancel() {
      this.resolve(false);
      this.closeDialog();
      this.$emit('cancel');
    },

    closeDialog() {
      this.$emit('input', { ...this.value, dialog: false });
      this.dialog = false;
    }
  }
};
</script>
